import { memo, useCallback } from 'react';

import { type Board } from '@air/api/types';

import { PublicExtensionsSelect } from '~/components/Filters/ExtensionFilter/components/PublicExtensionsSelect';
import { type BaseFilterCardProps } from '~/components/Filters/FilterCard';
import { StringArrayFilterCard } from '~/components/Filters/StringArrayFilterCard';
import { type BaseStringSelectProps } from '~/components/StringSelect';

export type PublicExtensionsFilterCardProps = {
  boardId: Board['id'] | undefined;
} & BaseFilterCardProps;

export const PublicExtensionsFilterCard = memo(({ boardId, ...props }: PublicExtensionsFilterCardProps) => {
  const renderExtensionsSelect = useCallback(
    (props: BaseStringSelectProps) => <PublicExtensionsSelect {...props} boardId={boardId} />,
    [boardId],
  );

  return (
    <StringArrayFilterCard
      filter="extensions"
      filterCardType="extension"
      StringSelect={renderExtensionsSelect}
      {...props}
    />
  );
});

PublicExtensionsFilterCard.displayName = 'PublicExtensionsFilterCard';
